import { PayloadAction } from '@reduxjs/toolkit';
import { FormatData, FormatState } from 'src/store/format/types';

const setCurrentFormatReducer = (state: FormatState, action: PayloadAction<FormatData|undefined>) => {
  state.currentFormat = action.payload;
};

export default setCurrentFormatReducer;
